import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material';

import { CategoryTile } from './components';
import { categoryService } from '../../services';
import SectionList from '../../components/styles/list/sectionList';

function CategorysPage() {
  const [error, setError] = useState();
  const [state, setState] = useState({
    loading: true,
    categories: [],
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (error) return () => { };

    categoryService.getAll().then((list) => {
      list = list || [];
      const categories = list.map((category) => (
        <CategoryTile
          key={category.id.toString()}
          category={category}
        />
      ));
      setState((oldState) => ({
        ...oldState,
        loading: false,
        categories,
      }));
    }).catch((err) => {
      setError(err);
    });

    return () => { };
  }, [error]);

  // Throwing errors which the AppBoundary can catch
  // Errors thrown inside useEffect are not catched by the boundary
  useEffect(() => {
    if (error) {
      const err = error;
      setError(null);
      throw err;
    }
  }, [error]);

  const handleClick = () => {
    navigate('/categories/new');
  };

  return state.loading
    ? (
      <CircularProgress />
    )
    : (
      <>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h5"><b>Categorias</b></Typography>
          <Button variant="contained" onClick={handleClick}>
            + Adicionar
          </Button>
        </Box>
        <Box sx={{
          mt: 2, maxHeight: '60vh', bgcolor: 'transparent',
        }}
        >
          <SectionList variant="sectionList">
            {state.categories}
          </SectionList>
        </Box>
      </>
    );
}

export default CategorysPage;
